import { Component, Input } from '@angular/core';
import { ComponentWithCopy } from '../../intefaces/interfaces';
import { HeadlineLarge } from '../../components/typography/headline-large/headline-large';
import { BodyLarge } from '../../components/typography/body-large/body-large';

@Component({
  selector: 'app-feature-centered-2-by-2-grid',
  imports: [HeadlineLarge, BodyLarge],
  templateUrl: './feature-centered-2-by-2-grid.html',
  styleUrl: './feature-centered-2-by-2-grid.css'
})
export class FeatureCentered2By2Grid {
  @Input() content!: ComponentWithCopy

}
